// @ts-nocheck
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { CategoriesPreviewCard } from "./CategoriesPreviewCard";
import {
  fetchProductsFromApi,
  selectAllProducts,
  selectProductsStatus,
} from "../stores/menu/productsSlice";
import {
  fetchServicesFromApi,
  selectAllServices,
  selectServicesStatus,
} from "../stores/menu/servicesSlice";
import { useLanguageContext } from "../context/languageContext";

export const CategoriesPreview = ({ roomId = null }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useLanguageContext();
  const businessId = useSelector((state) => state.business.businessId);

  const isServiceContext = location.pathname.includes("room-service");

  const data = useSelector(isServiceContext ? selectAllServices : selectAllProducts);
  const status = useSelector(isServiceContext ? selectServicesStatus : selectProductsStatus);

  useEffect(() => {
    if (businessId) {
      if (isServiceContext) {
        // For services, we don't need roomId in the URL anymore
        dispatch(fetchServicesFromApi({ businessid: businessId, roomid: '1' }));
      } else {
        dispatch(fetchProductsFromApi({ businessid: businessId }));
      }
    }
  }, [businessId, dispatch, isServiceContext]);

  if (status === "loading") {
    return (
      <div className="px-4 py-8 space-y-4">
        <div className="h-8 w-1/2 bg-slate-200 rounded animate-pulse"></div>
        <div className="grid grid-cols-2 gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="aspect-square bg-slate-200 rounded-3xl animate-pulse"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <section className="page-padding app-section">
      <div className="flex items-center justify-between mb-6">
        <div className="space-y-1">
          <h2 className="text-xl font-clash text-slate-950">
            {isServiceContext ? t("The Selection") : t("The Menu")}
          </h2>
          <div className="h-1 w-8 bg-indigo-600 rounded-full"></div>
        </div>
      </div>

      {data && data.length > 0 ? (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
          {data.map((category, index) => (
            <Link
              key={index}
              to={
                isServiceContext
                  ? `/room-service/services?categoryId=${category.id}`
                  : `/menu?categoryId=${category.id}&businessId=${businessId}`
              }
              className="animate-app-reveal"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <CategoriesPreviewCard category={category} index={index} />
            </Link>
          ))}
        </div>
      ) : (
        <div className="py-20 text-center">
          <p className="text-slate-400 text-sm font-medium">{t("Coming Soon")}</p>
        </div>
      )}
    </section>
  );
};
